/**
 * Utility functions for managing supplier invites via API
 * Uses backend endpoints instead of localStorage
 */

import { API } from './interceptor'

/**
 * Get all invites for a venue
 */
export const getSupplierInvites = async venueId => {
  if (!venueId) return []

  try {
    const response = await API.get('api2', `suppliers/invites/${venueId}`)
    if (response.success) {
      return response.data || []
    }
    return []
  } catch (error) {
    console.error('Error reading supplier invites from API:', error)
    return []
  }
}

/**
 * Add a new invite
 * Note: This is now handled by the backend when calling requestNewSupplier
 * Keeping for backwards compatibility but it's a no-op since invites are saved server-side
 */
// eslint-disable-next-line no-unused-vars
export const addSupplierInvite = async (venueId, inviteData) => {
  // Invites are now saved automatically by the backend when calling requestNewSupplier
  // This function is kept for backwards compatibility
  return true
}

/**
 * Remove an invite by ID
 */
export const removeSupplierInvite = async (venueId, inviteId) => {
  if (!venueId || !inviteId) return false

  try {
    const response = await API.delete('api2', `suppliers/invites/${inviteId}`)
    return response.success === true
  } catch (error) {
    console.error('Error removing supplier invite from API:', error)
    return false
  }
}

/**
 * Check if a supplier exists in venueSuppliers and remove matching invites
 * This is now handled by the backend automatically, but keeping for backwards compatibility
 */
// eslint-disable-next-line no-unused-vars
export const removeMatchingInvites = async (venueId, venueSuppliers) => {
  // Auto-removal is now handled by the backend when suppliers become active
  // This function is kept for backwards compatibility but does nothing
  return 0
}

/**
 * Format date as DD/MM/YYYY HH:mm
 */
export const formatInviteDate = isoString => {
  try {
    const date = new Date(isoString)
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    return `${day}/${month}/${year} ${hours}:${minutes}`
  } catch (error) {
    return 'Invalid date'
  }
}
